<div *ngIf="examModel" class="mti-teeth"
     style="width: 100%; max-width: 100%; padding: 4px; display: flex; max-height: 100%; overflow-y: auto; overflow-x: hidden;" data-cy="mti-teeth-main-container">
  <div style="flex-basis: 130px; min-width: 130px; display: flex; flex-direction: column;" data-cy="mti-teeth-labels-column">
    <!--LABELS-->
    <div style="height: 24px; min-height: 24px;" data-cy="mti-teeth-label-spacer"></div>
    <div style="background-color: #6fcf97; border-top-left-radius: 6px; border-top-right-radius: 6px;"
         class="mti-label" data-cy="mti-teeth-autofill-label">Autofill:
    </div>
    <div style="background-color: #f2c94c;" class="mti-label" data-cy="mti-teeth-tooth-label">Tooth:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-chief-complaint-label">Chief Complaint:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-palpitation-label">Palpitation:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-percussion-label">Percussion:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-mobility-label">Mobility:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-bite-label">Bite:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-chewing-label">Chewing:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-air-label">Air:</div>
    <div class="mti-label mti-cold" data-cy="mti-teeth-cold-label">Cold:</div>
    <div class="mti-label mti-hot" data-cy="mti-teeth-hot-label">Hot:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-ept-label">EPT:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-sinus-track-label">Sinus Track:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-occusal-trauma-label">Occusal Trauma:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-fracture-label">Fracture:</div>
    <div class="mti-label mti-hot" data-cy="mti-teeth-pulp-diag-label">Pulp Diag:</div>
    <div class="mti-label mti-light-green" data-cy="mti-teeth-periapical-diag-label">Periapical Diag:</div>
    <div class="mti-label mti-dark-green" data-cy="mti-teeth-endo-prognosis-label">Endo Prognosis:</div>
    <div class="mti-label mti-light-blue" data-cy="mti-teeth-perio-prognosis-label">Perio Prognosis:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-restorative-prognosis-label">Restorative Prognosis:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-recommended-tx-label">Recommended Tx:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-after-recommended-tx-label">After Recommended Tx:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-third-recommended-tx-label">3rd Recommended Tx:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-treatment-order-label">Treatment Order:</div>
    <div class="mti-label mti-light" data-cy="mti-teeth-visits-label">Estimated # of Visits:</div>
    <div class="mti-label mti-dark" data-cy="mti-teeth-date-label">Date:</div>
    <div style="height: 146px; min-height: 146px; display: flex; flex-direction: column;" data-cy="mti-teeth-visibility-toggle-container">
      <div style="flex: 1;"></div>
      <div *ngIf="!isSingleToothDialogMode" (click)="isShowMore = !isShowMore" style="color: var(--tdo-secondary);" data-cy="mti-teeth-visibility-toggle">
        <mat-icon *ngIf="isShowMore" data-cy="mti-teeth-visibility-on-icon">visibility</mat-icon>
        <mat-icon *ngIf="!isShowMore" data-cy="mti-teeth-visibility-off-icon">visibility_off</mat-icon>
      </div>
    </div>
    <div *ngIf="isShowMore || isSingleToothDialogMode" style="display: flex; flex-direction: column;" data-cy="mti-teeth-more-labels">
      <div class="mti-label mti-light" data-cy="mti-teeth-vital-test-cavity-label">Vital Test Cavity:</div>
      <div class="mti-label mti-dark" data-cy="mti-teeth-sweets-label">Sweets:</div>
      <div class="mti-label mti-light" data-cy="mti-teeth-flossing-label">Flossing:</div>
      <div class="mti-label mti-dark" data-cy="mti-teeth-lying-down-label">Lying Down:</div>
      <div class="mti-label mti-light" data-cy="mti-teeth-excercise-bp-label">Excercise BP:</div>
      <div class="mti-label mti-dark" data-cy="mti-teeth-head-position-label">Head Position:</div>
      <div class="mti-label mti-light" data-cy="mti-teeth-cervical-sensitivity-label">Cervical Sensitivity:</div>
      <div class="mti-label mti-dark" data-cy="mti-teeth-b-lateral-force-label">B Lateral Force:</div>
      <div class="mti-label mti-light" data-cy="mti-teeth-l-lateral-force-label">L Lateral Force:</div>
    </div>
  </div>
  <!--INPUTS-->
  <div style="flex-basis: 1px;"></div>
  <div style="flex: 1; height: fit-content; display: flex; overflow-x: hidden;" data-cy="mti-teeth-inputs-container">
    <div style="max-width: 100%; width: 100%; overflow-x: auto; display: flex;" cdkDropList (cdkDropListDropped)="onDropRow($event)" cdkDropListOrientation="horizontal" [cdkDropListDisabled]="isSingleToothDialogMode" data-cy="mti-teeth-tooth-list">
      <div style="width: 100%; height: 300px; font-size: 16px; color: var(--tdo-primary); text-align: center;" *ngIf="examModel.dataEndoMutiToothExamTeethinExams.length == 0" data-cy="mti-teeth-empty-state">
        <div (click)="onAddNew()" style="font-weight: 500; cursor: pointer; position: relative; top: 200px;" data-cy="mti-teeth-add-first-tooth">
          Click here to add your first tooth <mat-icon style="position: relative; top: 6px;" data-cy="mti-teeth-add-first-tooth-icon">add_circle_outline</mat-icon>
        </div>
      </div>
      <div *ngFor="let tooth of examModel.dataEndoMutiToothExamTeethinExams; let i = index" cdkDrag cdkDragLockAxis="x"
           style="flex-basis: 144px; min-width: 144px; margin-left: 1px; display: flex; flex-direction: column;" data-cy="mti-teeth-tooth-column-{{i}}">
        <!--LABELS-->
        <div style="height: 24px; min-height: 24px; display: flex; font-size: 10px;" data-cy="mti-teeth-tooth-actions-{{i}}">
          <div *ngIf="this.checkIsLocked(tooth)" (click)="toggleLock(tooth)"
               style="color: var(--tdo-secondary-accent); cursor: pointer; position: relative; top: -1px;" data-cy="mti-teeth-tooth-lock-toggle-{{i}}">
            <mat-icon matTooltip="Unlock" *ngIf="tooth.isLocked" data-cy="mti-teeth-tooth-unlock-icon-{{i}}">lock</mat-icon>
            <mat-icon matTooltip="Lock" *ngIf="!tooth.isLocked" data-cy="mti-teeth-tooth-lock-icon-{{i}}">lock_open</mat-icon>
          </div>
          <div matTooltip="Clear" (click)="clear(tooth)"
               style="color: var(--tdo-secondary); cursor: pointer; position: relative; top: -1px;" data-cy="mti-teeth-tooth-clear-{{i}}">
            <mat-icon data-cy="mti-teeth-tooth-clear-icon-{{i}}">clear</mat-icon>
          </div>
          <div *ngIf="!isSingleToothDialogMode" matTooltip="Delete" (click)="delete(tooth)"
               style="color: var(--tdo-secondary); cursor: pointer; position: relative; top: -1px;" data-cy="mti-teeth-tooth-delete-{{i}}">
            <mat-icon data-cy="mti-teeth-tooth-delete-icon-{{i}}">delete</mat-icon>
          </div>
          <div *ngIf="!isSingleToothDialogMode" matTooltip="Save to Treatment Plan / Bind tooth to case" (click)="download(tooth)"
               style="color: var(--tdo-primary-accent); cursor: pointer; position: relative; top: -1px;" data-cy="mti-teeth-tooth-save-{{i}}">
            <mat-icon data-cy="mti-teeth-tooth-save-icon-{{i}}">save</mat-icon>
          </div>
        </div>
        <div style="background-color: #6fcf97; border-top-left-radius: 6px; border-top-right-radius: 6px;"
             class="mti-label" data-cy="mti-teeth-tooth-autofill-{{i}}">
          <tdo-dropdown-v2 [isDisabled]="tooth.isLocked" [datasource]="examAutofills" displayProperty="AutofillName" (selectionChange)="onAutofillSelectionChange($event, tooth);" data-cy="mti-teeth-tooth-autofill-dropdown-{{i}}"></tdo-dropdown-v2>
        </div>
        <div style="background-color: #f2c94c; display: flex;" class="mti-label">
          <div style="flex: 1; text-align: left;">{{getToothNum(tooth.dataEndoMutiToothExamTooth)}}</div>
          <div *ngIf="!tooth.isLocked && !isSingleToothDialogMode" (click)="openToothPicker(tooth)" style="flex-basis: 20px; height: 20px; cursor:pointer;">
            <img style="width: 100%;" src="assets/Images/Calendar/iconToothNew.svg" />
          </div>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEChiefComplaintID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEChiefComplaintID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEChiefComplaint" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEPalpationID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEPalpationID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEPalpation" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEPercussionID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEPercussionID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEPercussion" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEMobilityID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEMobilityID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEMobility" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEBiteID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEBiteID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEBite" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEChewingID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEChewingID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEChewing" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEAirID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEAirID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEAir" ></app-tdo-enum-select>
        </div>
        <div class="mti-label" style="background-color: #a9a9ff;">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEColdID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEColdID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTECold" ></app-tdo-enum-select>
        </div>
        <div class="mti-label" style="background-color: #ffb5b5;">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEHotID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEHotID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEHot" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEeptID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEeptID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEept" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTESinusTrackID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTESinusTrackID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTESinusTrack" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEOccusalTraumaID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEOccusalTraumaID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEOccusalTrauma" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEFractureID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEFractureID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEFracture" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEPulpDiagID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEPulpDiagID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEPulpDiag" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEPerDiagID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEPerDiagID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEPerDiag" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEEndoPrognosisID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEEndoPrognosisID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEEndoPrognosis" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEPerioPrognosisID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEPerioPrognosisID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTEPerioPrognosis" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTERestorPrognosisID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTERestorPrognosisID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTERestorPrognosis" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTERecomendedTxID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTERecomendedTxID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTERecomendedTx" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTERecomendedTx_AfterID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTERecomendedTx_AfterID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTERecomendedTx" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTERecomendedTx_ThirdID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTERecomendedTx_ThirdID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTERecomendedTx" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-light-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTETretmentOrderID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTETretmentOrderID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTETretmentOrder" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark-grey">
          <app-tdo-enum-select [isDisabled]="tooth.isLocked"
            [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID"
            (isUserInput)="setUserInput($event)"
            (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTENumberOfVisitsID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
            name="enumMTENumberOfVisits" ></app-tdo-enum-select>
        </div>
        <div class="mti-label mti-dark"><input readonly [value]="getDate(tooth.xauditCreatedOn)"/></div>
        <div style="height: 146px; min-height: 146px; display: flex; flex-direction: column;">
          <div style="flex-basis: 1px;"></div>
          <div class="ui-dark-background mti-light" style="flex: 1; font-size: 12px; overflow-y: hidden;">
            <div style="flex-basis: fit-content;">Caries: <mat-checkbox [checked]="tooth.dataEndoMutiToothExamTooth.isCavity" (change)="tooth.dataEndoMutiToothExamTooth.isCavity = $event.checked; saveTooth(tooth);" [disabled]="tooth.isLocked" style="margin-top: 3px;"></mat-checkbox></div>
            <div style="display: flex; flex-wrap: wrap; font-size: 10px; height: 100%; max-height: 100%; overflow-y: auto;">
              <ng-container *ngFor="let surface of getToothSurfaces(tooth)">
                <mat-checkbox style="height: 16px; margin-right: 1px; margin-left: 1px;" [checked]="isToothHasSurfaceSelected(tooth, surface)" (change)="onSurfaceSelection($event, tooth, surface)"
                              [disabled]="tooth.isLocked" labelPosition="after">
                </mat-checkbox>{{surface.ItemSValue}}
              </ng-container>
            </div>
          </div>
          <div style="flex-basis: 1px;"></div>
          <div class="ui-dark-background mti-light" style="flex: 1; font-size: 12px; overflow-y: hidden;">
            <div style="display: flex; height: 100%;">
              <div style="flex: 1;">
                <div style="overflow: hidden; display: flex; flex-wrap: wrap; font-size: 10px; height: 100%; max-height: 100%; padding-top: 3px;">
                  <ng-container *ngFor="let surface of getToothSurfaces(tooth)">
                    <div style="display: flex; flex-basis: 60px; height: fit-content;">
                      <div style="flex-basis: 20px; text-align: right; position: relative; top: 3px; min-width: 20px; max-width: 20px;">{{surface.ItemSValue}}</div>
                      <div style="flex-basis: 3px; min-width: 5px;"></div>
                      <div style="border-radius: 3px; overflow: hidden; color: white; flex-basis: 33px; max-width: 33px; min-width: 33px; height: 20px; background-color: white;">
                        <tdo-dropdown-v2 selectClass="surface-depth-select" optionClass="surface-depth-option" [id]="tooth.MTETiithInExanID + '' + surface.ValidValueItemId" (selectionChange)="onProbingDepthChange($event, tooth, surface)" [value]="getSelectedToothSurfaceProbingDepth(tooth, surface)" [isDisabled]="isLocked" placeholder="" [datasource]="probingDepthEnums" displayProperty="ItemDisplayValue"></tdo-dropdown-v2>
                      </div>
                      <div style="flex-basis: 2px; min-width: 2px;"></div>
                    </div>
                  </ng-container>
                </div>
              </div>
              <div style="flex-basis: 15px; min-width: 15px;">
                <div (click)="autofillProbingDepths(tooth)" matTooltip="Autofill" style="cursor: pointer; transform: scale(0.5); position: relative; top: -2px; left: -2px;"><mat-icon>hdr_auto</mat-icon></div>
              </div>
            </div>
          </div>
          <div style="flex-basis: 1px;"></div>
        </div>
        <div *ngIf="isShowMore || isSingleToothDialogMode" style="display: flex; flex-direction: column;">
          <div class="mti-label mti-light-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEVitalTestCavityID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEVitalTestCavityID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTEVitalTestCavity" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-dark-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTESweetsID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTESweetsID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTESweets" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-light-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEFlossingID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEFlossingID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTEFlossing" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-dark-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTELayingDownID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTELayingDownID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTELayingDown" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-light-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEExersiseBPID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEExersiseBPID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTEExersiseBP" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-dark-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEHeadPosistionID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEHeadPosistionID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTEHeadPosistion" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-light-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTECervicalSensID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTECervicalSensID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTECervicalSens" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-dark-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTEBLateralForceID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTEBLateralForceID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTEBLateralForce" ></app-tdo-enum-select>
          </div>
          <div class="mti-label mti-light-grey">
            <app-tdo-enum-select [isDisabled]="tooth.isLocked"
              [validValueItemId]="tooth.dataEndoMutiToothExamTooth.enumMTELLateralForceID"
              (isUserInput)="setUserInput($event)"
              (enumSelected)="tooth.dataEndoMutiToothExamTooth.enumMTELLateralForceID = $event.ValidValueItemId; saveToothEvent($event, tooth);"
              name="enumMTELLateralForce" ></app-tdo-enum-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isSingleToothDialogMode" style="flex-basis: 20px;">
    <div matTooltip="Add Tooth" (click)="onAddNew()" style="cursor:pointer; color: var(--tdo-secondary);">
      <mat-icon>add_circle_outline</mat-icon>
    </div>
  </div>
</div>
